// extracted by mini-css-extract-plugin
export var select = "_qc-0";